module.exports = __webpack_public_path__ + "img/PREST_LOGO_RVB_noir.e4af48b5.svg";